import classNames from 'classnames';
import { Button, ButtonGroup } from 'reactstrap';

function ProjectToggles({
  favorite, active
}: {
  favorite: { value: boolean, toggle: (newValue: boolean) => void },
  active: { value: boolean, toggle: (newValue: boolean) => void }
}) {

  return (
    <ButtonGroup className='w-100'>
      <Button block={true} active={favorite.value} color={'warning'} onClick={() => favorite.toggle(!favorite.value)}>
        <i className={classNames({
          'fa-fw fa-heart me-2 text-danger': true,
          'fas': favorite.value,
          'far': !favorite.value,
        })} />
        {!favorite.value ? 'Non-Favorite' : 'Favorite'}
      </Button>
      <Button block={true} active={active.value} color={'primary'} onClick={() => active.toggle(!active.value)}>
        <i className={classNames({
          'fa-fw fa-lightbulb me-2 text-warning': true,
          'fas': active.value,
          'far': !active.value,
        })} />
        {active.value ? 'Active' : 'Inactive'}
      </Button>
    </ButtonGroup>
  );
}

export default ProjectToggles;
